export default {
  calculatedCosts: {
    salesPrice: 0,
    margin: 0,
    marginPercentage: 0,
    marginTime: 0,
    totalExpenditure: 0,
    hours: 0,
    turnoverPerHour: 0,
    daysWork: 0,
  },
  labour: 0,
  travel: 0,
  totalWage: 0,
  totalMaterials: 0,
  totalAssets: 0,
  totalArea: 0,
  totalSubcontracting: 0,
  totalTravelUnits: 0,
  labourWage: {
    labourWageExecutionComment: '',
    travelCostsComment: '',
  },
  materials: [
    {
      name: 'Icopal Products',
      name_nor: 'Icopal Produkter',
      comment: '',
      editable: false,
      unit: 1,
      price: 0,
      totalCost: 0,
    },
    {
      name: 'Other Products',
      name_nor: 'Andre produkter',
      comment: '',
      editable: false,
      unit: 1,
      price: 0,
      totalCost: 0,
    },
    {
      name: 'Mechanical Attachment',
      name_nor: 'Festemidler',
      comment: '',
      editable: true,
      unit: 0,
      price: 0,
      totalCost: 0,
    },
    {
      name: 'Other',
      name_nor: 'Annen',
      comment: '',
      editable: true,
      unit: 0,
      price: 0,
      totalCost: 0,
    },
    {
      name: 'Gas',
      name_nor: 'Gass',
      comment: '',
      editable: true,
      unit: 0,
      price: 0,
      totalCost: 0,
    },
    {
      name: 'Discount/Price Increases',
      name_nor: 'Rabatt / prisøkninger',
      comment: '',
      editable: true,
      unit: 0,
      price: 0,
      totalCost: 0,
    },
  ],
  assets: [
    {
      name: 'Transport',
      name_nor: 'Transportere',
      comment: '',
      unit: 0,
      price: 0,
      totalCost: 0,
    },
    {
      name: 'Lifting RS',
      name_nor: 'Heising RS',
      comment: '',
      unit: 0,
      price: 0,
      totalCost: 0,
    },
    {
      name: 'Container',
      name_nor: 'Container',
      comment: '',
      unit: 0,
      price: 0,
      totalCost: 0,
    },
    {
      name: 'Other',
      name_nor: 'Annen',
      comment: '',
      unit: 0,
      price: 0,
      totalCost: 0,
    },
  ],
  subcontracting: [
    {
      name: 'Beaters',
      name_nor: 'Blikkenslager',
      comment: '',
      unit: 0,
      price: 0,
      totalCost: 0,
    },
    {
      name: 'Other',
      name_nor: 'Annen',
      comment: '',
      unit: 0,
      price: 0,
      totalCost: 0,
    },
  ],
};
